import script from "./AppUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppUser.vue?vue&type=script&lang=ts&setup=true"

import "./AppUser.vue?vue&type=style&index=0&id=b55acd16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b55acd16"]])

export default __exports__